<button
  class="base-button"
  type="button"
  [ngClass]="{
    'button-primary': type === ButtonTypeEnum.primary,
    'button-secondary': type === ButtonTypeEnum.secondary,
    'button-negative': type === ButtonTypeEnum.negative,
    'button-disabled': disabled,
    'button-loading': loading,
  }"
  [disabled]="disabled || loading"
  (click)="!disabled && buttonClick.emit()">
  <div class="button-content">
    <ng-content></ng-content>
  </div>
  <div class="loading-indicator">
    <img class="loading-indicator-icon" src="assets/icons/grey/Loading.svg" alt="loading" i18n-alt />
  </div>
</button>
